import { create } from "zustand";

import type { AuthState, SlumbrUser } from "../types/user";

interface UserStore extends AuthState {
  setUser: (user: SlumbrUser) => void;
  setAccessToken: (token: string) => void;
  setLoading: (loading: boolean) => void;
  logout: () => void;
  updatePresence: (presence: Partial<SlumbrUser["presence"]>) => void;
  updatePreferences: (prefs: Partial<SlumbrUser["preferences"]>) => void;
}

export const useUserStore = create<UserStore>((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,
  accessToken: null,

  setUser: (user) =>
    set({ user, isAuthenticated: true, isLoading: false }),

  setAccessToken: (accessToken) =>
    set({ accessToken }),

  setLoading: (isLoading) =>
    set({ isLoading }),

  logout: () =>
    set({
      user: null,
      isAuthenticated: false,
      isLoading: false,
      accessToken: null,
    }),

  updatePresence: (presence) =>
    set((state) => ({
      user: state.user
        ? { ...state.user, presence: { ...state.user.presence, ...presence } }
        : null,
    })),

  updatePreferences: (prefs) =>
    set((state) => ({
      user: state.user
        ? {
            ...state.user,
            preferences: { ...state.user.preferences, ...prefs },
          }
        : null,
    })),
}));
